import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const TextTypography = withStyles({
  root: {
    color: '#0073a8',
    fontFamily: 'Helvetica',
    paddingBottom: 20,
  },
})(Typography);

export default function Title(props) {
  return (
    <TextTypography
      component="h2"
      variant="h4"
      style={{ fontSize: [props.size] }}
    >
      {props.text}
    </TextTypography>
  );
}

Title.propTypes = {
  text: PropTypes.string,
  size: PropTypes.string,
};
